export default {
  event_id () {
    return this.$store.state.eventForm.event_id
  },
  event_no () {
    return this.$store.state.eventForm.event_no
  },
  event_name: {
    set (value) {
      this.$store.commit('updateEventName', value)
    },
    get () {
      return this.$store.state.eventForm.event_name
    }
  },
  lecturer_name: {
    set (value) {
      this.$store.commit('updateLecturerName', value)
    },
    get () {
      return this.$store.state.eventForm.lecturer_name
    }
  },
  event_date: {
    set (value) {
      this.$store.commit('updateEventDate', value)
    },
    get () {
      return this.$store.state.eventForm.event_date
    }
  },
  event_date_public: {
    set (value) {
      this.$store.commit('updateEventDatePublic', value)
    },
    get () {
      return this.$store.state.eventForm.event_date_public
    }
  },
  event_date_public_multi: {
    set (value) {
      this.$store.commit('updateEventDatePublic', value)
    },
    get () {
      return this.$store.state.eventForm.event_date_public_multi
    }
  },
  venue: {
    set (value) {
      this.$store.commit('updateVenue', value)
    },
    get () {
      return this.$store.state.eventForm.venue
    }
  },
  inquiry: {
    set (value) {
      this.$store.commit('updateInquiry', value)
    },
    get () {
      return this.$store.state.eventForm.inquiry
    }
  },
  lecturer_url: {
    set (value) {
      this.$store.commit('updateLecturerUrl', value)
    },
    get () {
      return this.$store.state.eventForm.lecturer_url
    }
  },
  description: {
    set (value) {
      this.$store.commit('updateDescription', value)
    },
    get () {
      return this.$store.state.eventForm.description
    }
  },
  fee: {
    set (value) {
      this.$store.commit('updateFee', value)
    },
    get () {
      return this.$store.state.eventForm.fee
    }
  },
  entry_url: {
    set (value) {
      this.$store.commit('updateEntryUrl', value)
    },
    get () {
      return this.$store.state.eventForm.entry_url
    }
  },
  parking: {
    set (value) {
      this.$store.commit('updateParking', value)
    },
    get () {
      return this.$store.state.eventForm.parking
    }
  },
  participant: {
    set (value) {
      this.$store.commit('updateParticipant', value)
    },
    get () {
      return this.$store.state.eventForm.participant
    }
  },
  sponsor: {
    set (value) {
      this.$store.commit('updateSponsor', value)
    },
    get () {
      return this.$store.state.eventForm.sponsor
    }
  },
  sponsor_name: {
    set (value) {
      this.$store.commit('updateSponsorName', value)
    },
    get () {
      return this.$store.state.eventForm.sponsor_name
    }
  },
  images: {
    set (value) {
      this.$store.commit('updateImages', value)
    },
    get () {
      return this.$store.state.eventForm.images
    }
  },
  end_date: {
    set (value) {
      this.$store.commit('updateEndDate', value)
    },
    get () {
      return this.$store.state.eventForm.end_date
    }
  },
  published: {
    set (value) {
      this.$store.commit('updatePublished', value)
    },
    get () {
      return this.$store.state.eventForm.published
    }
  },
  status: {
    set (value) {
      this.$store.commit('updateStatus', value)
    },
    get () {
      return this.$store.state.eventForm.status
    }
  },
  event_kind: {
    set (value) {
      this.$store.commit('updateEventKind', value)
    },
    get () {
      return this.$store.state.eventForm.event_kind
    }
  },

  tel: {
    set (value) {
      this.$store.commit('updateTel', value)
    },
    get () {
      return this.$store.state.eventForm.inquiry.tel
    }
  },
  email: {
    set (value) {
      this.$store.commit('updateEmail', value)
    },
    get () {
      return this.$store.state.eventForm.inquiry.email
    }
  },

  venue_name: {
    set (value) {
      this.$store.commit('updateVenueName', value)
    },
    get () {
      return this.$store.state.eventForm.venue.venue_name
    }
  },
  homepage: {
    set (value) {
      this.$store.commit('updateHomepage', value)
    },
    get () {
      return this.$store.state.eventForm.venue.homepage
    }
  },
  zipcode: {
    set (value) {
      this.$store.commit('updateZipcode', value)
    },
    get () {
      return this.$store.state.eventForm.venue.zipcode
    }
  },
  prefecture: {
    set (value) {
      this.$store.commit('updatePrefecture', value)
    },
    get () {
      return this.$store.state.eventForm.venue.prefecture
    }
  },
  city: {
    set (value) {
      this.$store.commit('updateCity', value)
    },
    get () {
      return this.$store.state.eventForm.venue.city
    }
  },
  address1: {
    set (value) {
      this.$store.commit('updateAddress1', value)
    },
    get () {
      return this.$store.state.eventForm.venue.address1
    }
  },
  address2: {
    set (value) {
      this.$store.commit('updateAddress2', value)
    },
    get () {
      return this.$store.state.eventForm.venue.address2
    }
  },
  line_at: {
    set (value) {
      this.$store.commit('updateLineAt', value)
    },
    get () {
      return this.$store.state.eventForm.line_at
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/event_form/binder.js